import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/leandro/_git/baeta-advocacia/layouts/default.vue").then(m => m.default || m))
}